import { Routes } from "src/routes";
import { typeCheckAppModule } from "src/utils";
import { VotingPage } from "./VotingPage";

export const voting = typeCheckAppModule({
    NAME: "voting",
    Container: VotingPage,
    route: Routes.voting,
});
